import { useLocation } from "react-router-dom";

import { getLastNavigationSegmentName, RIDES_URL } from "@ryde/shared";

import { getRidesViewSwitchKey } from "./rides-kanban-switch.utils";

export const useRidesKanbanSwitchRoutes = () => {
  const location = useLocation();
  const navigateToSegment = getLastNavigationSegmentName(RIDES_URL);

  return {
    location,
    navigateToSegment,
    viewSwitchKey: getRidesViewSwitchKey(location.pathname),
  };
};
